import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/shared/ui/theme.css";
import { App } from "./App";
import { bootstrapAuth } from "@/shared/api/client";

async function main() {
  if (import.meta.env.VITE_MOCK_API === "1") {
    const { enableMocking } = await import("@/mocks/init");
    await enableMocking();
  }
  await bootstrapAuth();

  const root = document.getElementById("root");
  if (!root) throw new Error("main.tsx: #root не найден");
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void main();
